import { render, staticRenderFns } from "./zhichu2.vue?vue&type=template&id=5a7c43c4&scoped=true&"
import script from "./zhichu2.vue?vue&type=script&lang=js&"
export * from "./zhichu2.vue?vue&type=script&lang=js&"
import style0 from "./zhichu2.vue?vue&type=style&index=0&id=5a7c43c4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7c43c4",
  null
  
)

export default component.exports